import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center mt-20"
}
const _hoisted_2 = { class: "justify-center w-1/2 flex flex-col" }
const _hoisted_3 = { class: "w-full mx-auto rounded-lg border-2 border-sky-blue p-5 shadow-lg" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-2 text-2xl font-medium" }, "Metamounts Staking $MTM", -1)
const _hoisted_5 = {
  key: 0,
  class: "mt-5 pl-2 font-light"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-5 pl-2 font-light"
}
const _hoisted_7 = {
  key: 2,
  class: "mt-1 pl-2 font-light"
}
const _hoisted_8 = {
  key: 3,
  class: "mt-1 pl-2 font-light"
}
const _hoisted_9 = {
  key: 4,
  class: "mt-1 pl-2 font-light"
}
const _hoisted_10 = {
  key: 5,
  class: "mt-1 pl-2 font-light"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto text-center mt-20 mb-5 w-3/4" }, " Staking account associated to your wallet is not found... Create an account to start staking! ", -1)
const _hoisted_15 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "is-full-page": _ctx.fullPage,
      loader: _ctx.loader
    }, null, 8, ["active", "is-full-page", "loader"]),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (_ctx.farmAcc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Total Metamounts Staked: " + _toDisplayString(_ctx.farmAcc.gemsStaked), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, "Metamounts Staked: -")),
              (_ctx.farmAcc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "% of Metamounts Staked: " + _toDisplayString(Math.floor((parseInt(_ctx.farmAcc.gemsStaked)/1101.0 * 100 ) * 10)/10) + "%", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, "% of Metamounts Staked: -")),
              (_ctx.farmAcc && _ctx.magicEdenFloor && _ctx.solPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Minimum Value Locked: $" + _toDisplayString((Math.floor((parseInt(_ctx.farmAcc.gemsStaked) * _ctx.magicEdenFloor * _ctx.solPrice) * 100))/100), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, "Minimum Value Locked: -"))
            ]),
            _createVNode(_component_ConfigPane)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_FarmerDisplay, {
                  key: _ctx.farmerAcc,
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  farmer: _ctx.farmer,
                  farmerAcc: _ctx.farmerAcc,
                  class: "mb-10",
                  onRefreshFarmer: _ctx.handleRefreshFarmer
                }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
                _createVNode(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  farmerAcc: _ctx.farmerAcc,
                  farmerState: _ctx.farmerState,
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                  onFlashDepositWalletNft: _ctx.flashDepositSelectedNFT,
                  onFetchFarm: _ctx.fetchFarn,
                  onFetchFarmer: _ctx.fetchFarmer
                }, {
                  default: _withCtx(() => [
                    ((((_ctx.farmerAcc.rewardA.accruedReward - _ctx.farmerAcc.rewardA.paidOutReward) / (1000000000)) + (parseInt(_ctx.farmerAcc.gemsStaked) * (Math.round(_ctx.currentTS/1000) - _ctx.farmerAcc.rewardA.fixedRate.lastUpdatedTs) * 12 / 86400)) > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "nes-btn is-warning",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                        }, " Claim $MTM "))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["vault", "farmerAcc", "farmerState", "onSelectedWalletNft", "onFlashDepositWalletNft", "onFetchFarm", "onFetchFarmer"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    class: "nes-btn is-primary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, " Create Account ")
                ])
              ]))
        ]))
  ], 64))
}